import { render, staticRenderFns } from "./alarmNotice.vue?vue&type=template&id=4e935fdb&scoped=true&"
import script from "./alarmNotice.vue?vue&type=script&lang=js&"
export * from "./alarmNotice.vue?vue&type=script&lang=js&"
import style0 from "./alarmNotice.vue?vue&type=style&index=0&id=4e935fdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e935fdb",
  null
  
)

export default component.exports